import { Form, createDefaultFieldFactory } from "@sitecore-jss/sitecore-jss-react-forms";
import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { sitecoreApiHost, sitecoreApiKey } from "../../../../temp/config";
import BaseComponent from "../../../Base/BaseComponent";
import { FieldType_Constants } from "./Constants";
import {
  ConditionalFieldWrapper,
  ErrorComponent,
  FieldErrorComponent,
  UpdateFieldModel
} from "./CustomizeForm";

function handleOnChange(field, fieldValue, callback) {
  let valid = true;
  const errorMessages = [];

  if (field.model.required && !fieldValue) {
    valid = false;
    errorMessages.push(`${field.model.title} is required`);
  }

  callback(field.valueField.name, fieldValue, valid, errorMessages);
}

const defaultFieldFactory = createDefaultFieldFactory();
defaultFieldFactory.setComponent(FieldType_Constants.retailer_name_list, (props) => {
  return (
    <>
      <label htmlFor={props.field.valueField.id} className={props.field.model.labelCssClass}>{props.field.model.title}</label>
      <select className={`js-retailer-list ${props.field.model.cssClass}`} id={props.field.valueField.id} name={props.field.valueField.name} onChange={(e) => handleOnChange(props.field, e.target.value, props.onChange)}>
        <option label=" "></option>
        <option value="Loading...">Loading...</option>
      </select>
    </>
  );
});

class FoundationFormsForm extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="custom-form-container">
        {this.props.fields && (
          <BaseComponent margin="standard">
            <div className="custom-form" id="js-custom-form">
              <Form
                form={UpdateFieldModel(this.props.fields)}
                sitecoreApiHost={sitecoreApiHost}
                sitecoreApiKey={sitecoreApiKey}
                onRedirect={url => this.props.history.push(url)}
                fieldWrapperComponent={ConditionalFieldWrapper}
                errorComponent={ErrorComponent}
                fieldValidationErrorsComponent={FieldErrorComponent}
                fieldFactory={defaultFieldFactory}
              />
            </div>
          </BaseComponent>
        )}
      </div>
    );
  }
};

export default withRouter(FoundationFormsForm);
